export const COUNTRY_LIST: { name: string; code: string }[] = [
  { name: 'Andorra', code: 'AND' },
  { name: 'United Arab Emirates', code: 'ARE' },
  { name: 'Afghanistan', code: 'AFG' },
  { name: 'Antigua and Barbuda', code: 'ATG' },
  { name: 'Anguilla', code: 'AIA' },
  { name: 'Albania', code: 'ALB' },
  { name: 'Armenia', code: 'ARM' },
  { name: 'Angola', code: 'AGO' },
  { name: 'Antarctica', code: 'ATA' },
  { name: 'Argentina', code: 'ARG' },
  { name: 'American Samoa', code: 'ASM' },
  { name: 'Austria', code: 'AUT' },
  { name: 'Australia', code: 'AUS' },
  { name: 'Aruba', code: 'ABW' },
  { name: 'Åland', code: 'ALA' },
  { name: 'Azerbaijan', code: 'AZE' },
  { name: 'Bosnia and Herzegovina', code: 'BIH' },
  { name: 'Barbados', code: 'BRB' },
  { name: 'Bangladesh', code: 'BGD' },
  { name: 'Belgium', code: 'BEL' },
  { name: 'Burkina Faso', code: 'BFA' },
  { name: 'Bulgaria', code: 'BGR' },
  { name: 'Bahrain', code: 'BHR' },
  { name: 'Burundi', code: 'BDI' },
  { name: 'Benin', code: 'BEN' },
  { name: 'Saint Barthélemy', code: 'BLM' },
  { name: 'Bermuda', code: 'BMU' },
  { name: 'Brunei', code: 'BRN' },
  { name: 'Bolivia', code: 'BOL' },
  { name: 'Bonaire', code: 'BES' },
  { name: 'Brazil', code: 'BRA' },
  { name: 'Bahamas', code: 'BHS' },
  { name: 'Bhutan', code: 'BTN' },
  { name: 'Bouvet Island', code: 'BVT' },
  { name: 'Botswana', code: 'BWA' },
  { name: 'Belarus', code: 'BLR' },
  { name: 'Belize', code: 'BLZ' },
  { name: 'Canada', code: 'CAN' },
  { name: 'Cocos [Keeling] Islands', code: 'CCK' },
  { name: 'Democratic Republic of the Congo', code: 'COD' },
  { name: 'Central African Republic', code: 'CAF' },
  { name: 'Republic of the Congo', code: 'COG' },
  { name: 'Switzerland', code: 'CHE' },
  { name: 'Ivory Coast', code: 'CIV' },
  { name: 'Cook Islands', code: 'COK' },
  { name: 'Chile', code: 'CHL' },
  { name: 'Cameroon', code: 'CMR' },
  { name: 'China', code: 'CHN' },
  { name: 'Colombia', code: 'COL' },
  { name: 'Costa Rica', code: 'CRI' },
  { name: 'Cuba', code: 'CUB' },
  { name: 'Cape Verde', code: 'CPV' },
  { name: 'Curacao', code: 'CUW' },
  { name: 'Christmas Island', code: 'CXR' },
  { name: 'Cyprus', code: 'CYP' },
  { name: 'Czech Republic', code: 'CZE' },
  { name: 'Germany', code: 'DEU' },
  { name: 'Djibouti', code: 'DJI' },
  { name: 'Denmark', code: 'DNK' },
  { name: 'Dominica', code: 'DMA' },
  { name: 'Dominican Republic', code: 'DOM' },
  { name: 'Algeria', code: 'DZA' },
  { name: 'Ecuador', code: 'ECU' },
  { name: 'Estonia', code: 'EST' },
  { name: 'Egypt', code: 'EGY' },
  { name: 'Western Sahara', code: 'ESH' },
  { name: 'Eritrea', code: 'ERI' },
  { name: 'Spain', code: 'ESP' },
  { name: 'Ethiopia', code: 'ETH' },
  { name: 'Finland', code: 'FIN' },
  { name: 'Fiji', code: 'FJI' },
  { name: 'Falkland Islands', code: 'FLK' },
  { name: 'Micronesia', code: 'FSM' },
  { name: 'Faroe Islands', code: 'FRO' },
  { name: 'France', code: 'FRA' },
  { name: 'Gabon', code: 'GAB' },
  { name: 'United Kingdom', code: 'GBR' },
  { name: 'Grenada', code: 'GRD' },
  { name: 'Georgia', code: 'GEO' },
  { name: 'French Guiana', code: 'GUF' },
  { name: 'Guernsey', code: 'GGY' },
  { name: 'Ghana', code: 'GHA' },
  { name: 'Gibraltar', code: 'GIB' },
  { name: 'Greenland', code: 'GRL' },
  { name: 'Gambia', code: 'GMB' },
  { name: 'Guinea', code: 'GIN' },
  { name: 'Guadeloupe', code: 'GLP' },
  { name: 'Equatorial Guinea', code: 'GNQ' },
  { name: 'Greece', code: 'GRC' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'SGS' },
  { name: 'Guatemala', code: 'GTM' },
  { name: 'Guam', code: 'GUM' },
  { name: 'Guinea-Bissau', code: 'GNB' },
  { name: 'Guyana', code: 'GUY' },
  { name: 'Hong Kong', code: 'HKG' },
  { name: 'Heard Island and McDonald Islands', code: 'HMD' },
  { name: 'Honduras', code: 'HND' },
  { name: 'Croatia', code: 'HRV' },
  { name: 'Haiti', code: 'HTI' },
  { name: 'Hungary', code: 'HUN' },
  { name: 'Indonesia', code: 'IDN' },
  { name: 'Ireland', code: 'IRL' },
  { name: 'Israel', code: 'ISR' },
  { name: 'Isle of Man', code: 'IMN' },
  { name: 'India', code: 'IND' },
  { name: 'British Indian Ocean Territory', code: 'IOT' },
  { name: 'Iraq', code: 'IRQ' },
  { name: 'Iran', code: 'IRN' },
  { name: 'Iceland', code: 'ISL' },
  { name: 'Italy', code: 'ITA' },
  { name: 'Jersey', code: 'JEY' },
  { name: 'Jamaica', code: 'JAM' },
  { name: 'Jordan', code: 'JOR' },
  { name: 'Japan', code: 'JPN' },
  { name: 'Kenya', code: 'KEN' },
  { name: 'Kyrgyzstan', code: 'KGZ' },
  { name: 'Cambodia', code: 'KHM' },
  { name: 'Kiribati', code: 'KIR' },
  { name: 'Comoros', code: 'COM' },
  { name: 'Saint Kitts and Nevis', code: 'KNA' },
  { name: 'North Korea', code: 'PRK' },
  { name: 'South Korea', code: 'KOR' },
  { name: 'Kuwait', code: 'KWT' },
  { name: 'Cayman Islands', code: 'CYM' },
  { name: 'Kazakhstan', code: 'KAZ' },
  { name: 'Laos', code: 'LAO' },
  { name: 'Lebanon', code: 'LBN' },
  { name: 'Saint Lucia', code: 'LCA' },
  { name: 'Liechtenstein', code: 'LIE' },
  { name: 'Sri Lanka', code: 'LKA' },
  { name: 'Liberia', code: 'LBR' },
  { name: 'Lesotho', code: 'LSO' },
  { name: 'Lithuania', code: 'LTU' },
  { name: 'Luxembourg', code: 'LUX' },
  { name: 'Latvia', code: 'LVA' },
  { name: 'Libya', code: 'LBY' },
  { name: 'Morocco', code: 'MAR' },
  { name: 'Monaco', code: 'MCO' },
  { name: 'Moldova', code: 'MDA' },
  { name: 'Montenegro', code: 'MNE' },
  { name: 'Saint Martin', code: 'MAF' },
  { name: 'Madagascar', code: 'MDG' },
  { name: 'Marshall Islands', code: 'MHL' },
  { name: 'Macedonia', code: 'MKD' },
  { name: 'Mali', code: 'MLI' },
  { name: 'Myanmar [Burma]', code: 'MMR' },
  { name: 'Mongolia', code: 'MNG' },
  { name: 'Macao', code: 'MAC' },
  { name: 'Northern Mariana Islands', code: 'MNP' },
  { name: 'Martinique', code: 'MTQ' },
  { name: 'Mauritania', code: 'MRT' },
  { name: 'Montserrat', code: 'MSR' },
  { name: 'Malta', code: 'MLT' },
  { name: 'Mauritius', code: 'MUS' },
  { name: 'Maldives', code: 'MDV' },
  { name: 'Malawi', code: 'MWI' },
  { name: 'Mexico', code: 'MEX' },
  { name: 'Malaysia', code: 'MYS' },
  { name: 'Mozambique', code: 'MOZ' },
  { name: 'Namibia', code: 'NAM' },
  { name: 'New Caledonia', code: 'NCL' },
  { name: 'Niger', code: 'NER' },
  { name: 'Norfolk Island', code: 'NFK' },
  { name: 'Nigeria', code: 'NGA' },
  { name: 'Nicaragua', code: 'NIC' },
  { name: 'Netherlands', code: 'NLD' },
  { name: 'Norway', code: 'NOR' },
  { name: 'Nepal', code: 'NPL' },
  { name: 'Nauru', code: 'NRU' },
  { name: 'Niue', code: 'NIU' },
  { name: 'New Zealand', code: 'NZL' },
  { name: 'Oman', code: 'OMN' },
  { name: 'Panama', code: 'PAN' },
  { name: 'Peru', code: 'PER' },
  { name: 'French Polynesia', code: 'PYF' },
  { name: 'Papua New Guinea', code: 'PNG' },
  { name: 'Philippines', code: 'PHL' },
  { name: 'Pakistan', code: 'PAK' },
  { name: 'Poland', code: 'POL' },
  { name: 'Saint Pierre and Miquelon', code: 'SPM' },
  { name: 'Pitcairn Islands', code: 'PCN' },
  { name: 'Puerto Rico', code: 'PRI' },
  { name: 'Palestine', code: 'PSE' },
  { name: 'Portugal', code: 'PRT' },
  { name: 'Palau', code: 'PLW' },
  { name: 'Paraguay', code: 'PRY' },
  { name: 'Qatar', code: 'QAT' },
  { name: 'Réunion', code: 'REU' },
  { name: 'Romania', code: 'ROU' },
  { name: 'Serbia', code: 'SRB' },
  { name: 'Russia', code: 'RUS' },
  { name: 'Rwanda', code: 'RWA' },
  { name: 'Saudi Arabia', code: 'SAU' },
  { name: 'Solomon Islands', code: 'SLB' },
  { name: 'Seychelles', code: 'SYC' },
  { name: 'Sudan', code: 'SDN' },
  { name: 'Sweden', code: 'SWE' },
  { name: 'Singapore', code: 'SGP' },
  { name: 'Saint Helena', code: 'SHN' },
  { name: 'Slovenia', code: 'SVN' },
  { name: 'Svalbard and Jan Mayen', code: 'SJM' },
  { name: 'Slovakia', code: 'SVK' },
  { name: 'Sierra Leone', code: 'SLE' },
  { name: 'San Marino', code: 'SMR' },
  { name: 'Senegal', code: 'SEN' },
  { name: 'Somalia', code: 'SOM' },
  { name: 'Suriname', code: 'SUR' },
  { name: 'South Sudan', code: 'SSD' },
  { name: 'São Tomé and Príncipe', code: 'STP' },
  { name: 'El Salvador', code: 'SLV' },
  { name: 'Sint Maarten', code: 'SXM' },
  { name: 'Syria', code: 'SYR' },
  { name: 'Swaziland', code: 'SWZ' },
  { name: 'Turks and Caicos Islands', code: 'TCA' },
  { name: 'Chad', code: 'TCD' },
  { name: 'French Southern Territories', code: 'ATF' },
  { name: 'Togo', code: 'TGO' },
  { name: 'Thailand', code: 'THA' },
  { name: 'Tajikistan', code: 'TJK' },
  { name: 'Tokelau', code: 'TKL' },
  { name: 'East Timor', code: 'TLS' },
  { name: 'Turkmenistan', code: 'TKM' },
  { name: 'Tunisia', code: 'TUN' },
  { name: 'Tonga', code: 'TON' },
  { name: 'Turkey', code: 'TUR' },
  { name: 'Trinidad and Tobago', code: 'TTO' },
  { name: 'Tuvalu', code: 'TUV' },
  { name: 'Taiwan', code: 'TWN' },
  { name: 'Tanzania', code: 'TZA' },
  { name: 'Ukraine', code: 'UKR' },
  { name: 'Uganda', code: 'UGA' },
  { name: 'U.S. Minor Outlying Islands', code: 'UMI' },
  { name: 'United States', code: 'USA' },
  { name: 'Uruguay', code: 'URY' },
  { name: 'Uzbekistan', code: 'UZB' },
  { name: 'Vatican City', code: 'VAT' },
  { name: 'Saint Vincent and the Grenadines', code: 'VCT' },
  { name: 'Venezuela', code: 'VEN' },
  { name: 'British Virgin Islands', code: 'VGB' },
  { name: 'U.S. Virgin Islands', code: 'VIR' },
  { name: 'Vietnam', code: 'VNM' },
  { name: 'Vanuatu', code: 'VUT' },
  { name: 'Wallis and Futuna', code: 'WLF' },
  { name: 'Samoa', code: 'WSM' },
  { name: 'Kosovo', code: 'XKX' },
  { name: 'Yemen', code: 'YEM' },
  { name: 'Mayotte', code: 'MYT' },
  { name: 'South Africa', code: 'ZAF' },
  { name: 'Zambia', code: 'ZMB' },
  { name: 'Zimbabwe', code: 'ZWE' },
];

export const COUNTRIES: string[] = COUNTRY_LIST.map(country => country.name);

/**
 * Returns the ISO 3166-1 code for a country name. Used to map a stored passport country name to the
 * country code Equifax IDMatrix expects.
 */
export const getCountryCode = (name?: string): string | undefined =>
  COUNTRY_LIST.find(country => country.name === name)?.code;

export const AU_STATES_CODE = [
  {
    value: 'NSW',
    label: 'NSW',
  },
  {
    value: 'ACT',
    label: 'ACT',
  },
  {
    value: 'QLD',
    label: 'QLD',
  },
  {
    value: 'NT',
    label: 'NT',
  },
  {
    value: 'SA',
    label: 'SA',
  },
  {
    value: 'TAS',
    label: 'TAS',
  },
  {
    value: 'VIC',
    label: 'VIC',
  },
  {
    value: 'WA',
    label: 'WA',
  },
];

export const LABELS = {
  DWELLING_TYPE: 'Dwelling type',
  OCCUPANCY_STATUS: 'Occupancy status',
  UNIMPROVED_VALUE: 'Unimproved value',
  STREET_NUMBER: 'Street number',
  STREET_NAME: 'Street name',
  SUBURB: 'Suburb',
  STATE: 'State',
  POSTCODE: 'Postcode',
  UNIT_NUMBER: 'Unit number',
  HOME_ADDRESS: 'Home address',
  INSTALLATION_ADDRESS: 'Installation address',
  MANUAL_ADDRESS: 'Enter address manually',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  MIDDLE_NAME: 'Middle name',
  PASSPORT_NUMBER: 'Passport number',
  ISSUING_COUNTRY: 'Issuing country',
  DATE_OF_BIRTH: 'Date of birth',
  EXPIRY_DATE: 'Expiry date',
  IDENTIFICATION_TYPE: 'Identification type',
  MEDICARE_NUMBER: 'Medicare card number',
  MEDICARE_REFERENCE: 'Individual ref number',
  LICENCE_NUMBER: 'Licence number',
  LICENCE_CARD_NUMBER: 'Card number',
  PHOTO_ID_NUMBER: 'ID number',
  INCOME_TYPE: 'Primary income type',
  EMPLOYER_NAME: "Employer's business name",
  EMPLOYER_PHONE_NUMBER: "Employer's phone number",
  JOB_TITLE: 'Job title',
  INCOME_AFTER_TAX: 'Primary income after tax',
  NET_INCOME: 'Net income',
  ADDITIONAL_INCOME: 'Additional income',
  ADDITIONAL_INCOME_AFTER_TAX: 'Additional income after tax',
  TRADING_NAME: 'Trading name/ABN',
  BUSINESS_PHONE_NUMBER: 'Business phone number',
  RETIRED_OR_PENSIONER: 'Retired or pensioner',
  OTHER: 'Other',
  ACCOUNT_HOLDER: 'Account holder name',
  BSB: 'BSB',
  ACCOUNT_NUMBER: 'Account number',
  MARITAL_STATUS: 'Relationship status',
  DEPENDANTS: 'Dependants',
  PARTNER_INCOME: 'Partner income after tax',
  MORTGAGE_REPAYMENTS: 'Mortgage repayments',
  RENT: 'Rent',
  OTHER_LOANS: 'Other loans',
  CREDIT_CARDS: 'Credit cards',
  HOUSE_LIVING_EXPENSES: 'Household living expenses',
  EMAIL: 'Email',
  MOBILE_NUMBER: 'Mobile number',
  PHONE_NUMBER: 'Phone number',
  PROOF_ID: 'Proof of ID',
  OWNERSHIP_PERCENTAGE: 'Ownership percentage',
  EMAIL_ADDRESS: 'Email address',
  CORPORATE_ENTITIES_LABEL: 'Corporate entities associated with the business',
  NUMBER_OF_DIRECTORS_LABEL: 'Number of Directors',
};

export const ENTERPRISE_PARTNER = {
  COMMBANK: 'commbank',
  REWIRING_AU: 'rewiring-au',
  BRIGHTE: 'brighte',
  RACQ: 'racq',
};

export const FINANCIAL_PRODUCT = {
  ACT_SHS: 'act-shs-loan',
  TAS_ESLS: 'tas-esls-loan',
  ACT_SLIP: 'act-slip-loan',
  BGL: 'brighte-green-loan',
  BPL: 'brighte-personal-loan',
  ACT_SFA: 'act-solar-for-apartments-loan',
  FLEX: 'brighte-flex',
  ELECTRIFY_2515: 'electrify-2515',
  CBA_PARTNER: 'cba-partner',
  CBA_RESIDENTIAL: 'commbank-residential',
  BRIGHTE_PAY: 'brighte-pay',
  HEUF_LOAN: 'brighte-heuf-green-loan',
  SME: 'brighte-business',
  ACT_COMMUNITY: 'act-community-loan',
  BHESL: 'brighte-home-energy-saver-loan',
};

export const GOVERNMENT_FINANCIAL_PRODUCTS = [
  FINANCIAL_PRODUCT.ACT_SFA,
  FINANCIAL_PRODUCT.ACT_SHS,
  FINANCIAL_PRODUCT.ACT_SLIP,
  FINANCIAL_PRODUCT.TAS_ESLS,
];

export const BUSINESS_LOAN_PRODUCTS = [FINANCIAL_PRODUCT.SME, FINANCIAL_PRODUCT.ACT_COMMUNITY];

export const isBusinessLoanProduct = (financialProductId?: string): boolean =>
  !!financialProductId && BUSINESS_LOAN_PRODUCTS.includes(financialProductId);

export const APPLICATION_ID_LENGTH = 8;
export const DOCUMENT_ID_LENGTH = 36;
export const INCOME_DOCUMENT_VERIFICATION_TIMEOUT_MS = 5 * 60 * 1_000;

// for s3 service and file validation schema
export const MAX_FILE_SIZE_BYTES = 20971520; // 20 MB
export const MEGA_BYTE_TO_BYTE = 1048576;
export const MIN_FILE_SIZE_BYTES = 1024; // 1 KB
export const VALID_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];
// HEIC/HEIF is the default iPhone photo format. It is offered at the picker and transcoded to JPEG
// in the browser before the upload starts, so it is deliberately absent from VALID_FILE_EXTENSIONS
// (the server-side allowlist): no .heic ever reaches S3, Textract, Bedrock or finPOWER.
export const HEIC_FILE_EXTENSIONS = ['heic', 'heif'];
export const COMPRESSION_THRESHOLD_BYTES = 4 * MEGA_BYTE_TO_BYTE; // 4 MB
export const DOCUMENT_COMPRESS_ENDPOINT_PATH = '/v2/application-service/documents/compress';
export const ACCEPTED_FILE_TYPES: Record<string, string[]> = {
  'image/*': ['.jpeg', '.jpg', '.png', '.heic', '.heif'],
  'application/pdf': ['.pdf'],
};

export const PENSIONER_CODE_REQUIRED_INCOME_VERIFICATION = '2';
export const PENSIONER_CODE_NOT_REQUIRED_INCOME_VERIFICATION = '1';

export const E2515_CASH_APPLICATION_ANNUAL_INCOME_THRESHOLD = 78000;
export const BNPL_REQUIRE_INCOME_VERIFICATION_FINANCE_AMOUNT_THRESHOLD = 40000;

export enum UPDATE_APPLICATION_ACTION {
  ADD_JOINT = 'add-joint',
  WITHDRAW = 'withdraw',
}

// Shared between the backend (thrown as a BadRequestException) and the frontend (surfaced to the user verbatim),
// so the two stay in sync when the copy changes.
export const APPLICATION_ERROR_MESSAGES = {
  JOINT_APPLICANT_NOT_UNIQUE: 'Your partner must have a unique email and mobile number, separate from your details.',
  IDENTITY_VERIFICATION_UNSUCCESSFUL:
    'We couldn’t verify your identity with the details provided. Please check them and try again.',
};
